import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { render as renderApi } from "../../api/endpoints/render";
import { qk } from "../../api/queryKeys";
import type { ArtifactPinOut } from "../../api/types/onboardingRun";
import { ErrorBanner } from "../../components/ui/ErrorBanner";

export function ArtifactDrawer({ artifact }: { artifact: ArtifactPinOut }) {
  const [open, setOpen] = useState(false);
  const isDiff = artifact.name === "preview-diff.json";
  const body = useQuery({
    enabled: open,
    queryKey: qk.renderArtifact(artifact.content_sha256),
    queryFn: () => renderApi.artifact(artifact.content_sha256).then((r) => r.data),
  });
  return (
    <div style={{ display: "grid", gap: 6 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: "0.85rem" }}>
        <span style={{ color: "var(--text-dim)" }}>[{artifact.kind}]</span>
        <strong>{artifact.name}</strong>
        {isDiff && <span style={{ color: "var(--text-dim)", fontSize: "0.75rem" }}>approval diff evidence</span>}
        <code style={{ fontSize: "0.72rem", color: "var(--text-dim)" }}>{artifact.content_sha256.slice(0, 12)}</code>
        <button type="button" style={linkBtn} onClick={() => setOpen((o) => !o)}>
          {open ? "hide" : "view"}
        </button>
      </div>
      {open && body.isFetching && <p style={{ color: "var(--text-dim)" }}>Loading…</p>}
      {open && body.error && <ErrorBanner error={body.error} title={`Failed to load ${artifact.name}`} />}
      {open && body.data && (
        <pre
          style={{
            margin: 0, padding: 12, background: "var(--surface-2)",
            border: "1px solid var(--border)", borderRadius: 6,
            fontSize: "0.76rem", overflow: "auto", maxHeight: 360,
          }}
        >
          {body.data}
        </pre>
      )}
    </div>
  );
}

const linkBtn: React.CSSProperties = {
  background: "transparent", border: "none", color: "var(--accent)",
  cursor: "pointer", fontSize: "0.8rem", padding: 0, textDecoration: "underline",
};
